/* eslint-disable */

import { Component } from 'react';

class ErrorBoundary extends Component {
    constructor(props: any) {
        super(props);
        this.state = { hasError: false };
    }

    // Update state so the next render will show the fallback UI
    static getDerivedStateFromError(_error: any) {
        return { hasError: true };
    }

    // Use this for side effects like logging the error
    componentDidCatch(error: any, errorInfo: any) {
        console.error("Error caught by boundary:", error, errorInfo);
    }

    render() {
        // Type guard for state
        const state = this.state as { hasError: boolean };
        if (state.hasError) {
            // Custom fallback UI
            return <h1>Something went wrong. Please try again later.</h1>;
        }

        return (this.props as { children?: React.ReactNode }).children; /* @vite-ignore */
    }
}

export default ErrorBoundary;